import React, { useState } from 'react';
import {
    Card, Table, Tag, Typography, Button, Input, Select, Segmented, Space, DatePicker, Drawer, Descriptions, Tabs, Empty, message
} from 'antd';
import { DownloadOutlined, EyeOutlined, SearchOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;
const { RangePicker } = DatePicker;

// ══════════════════════════════════════════════
//  Mock 数据
// ══════════════════════════════════════════════
// TODO: 联调时替换为接口数据

// 平台视角账单列表（跨企业，含付费企业）
const MOCK_PLATFORM_BILLS = [
    { key: 'b1', billNo: 'TRAFFIC20260906', companyId: 'ENT_SZ01', companyName: 'test-深圳芯视界科技有限公司',
        billingDate: '2026-09-06', cnTraffic: 1280.50, cnAmount: 1024.40,
        overseasTraffic: 340.20, overseasAmount: 40.82, exchangeRate: 7.20, cnyPayable: 1318.30, status: 'paid' },
    { key: 'b2', billNo: 'TRAFFIC20260906', companyId: 'ENT_DG02', companyName: 'test-东莞康林物联网有限公司',
        billingDate: '2026-09-06', cnTraffic: 860.00, cnAmount: 688.00,
        overseasTraffic: 0, overseasAmount: 0, exchangeRate: 7.20, cnyPayable: 688.00, status: 'paid' },
    { key: 'b3', billNo: 'TRAFFIC20260906', companyId: 'ENT_BJ03', companyName: 'test-北京智联科技有限公司',
        billingDate: '2026-09-06', cnTraffic: 2100.30, cnAmount: 1260.18,
        overseasTraffic: 120.00, overseasAmount: 10.80, exchangeRate: 7.15, cnyPayable: 1337.40, status: 'failed' },
    { key: 'b4', billNo: 'TRAFFIC20260905', companyId: 'ENT_HZ04', companyName: 'test-杭州云睿电子有限公司',
        billingDate: '2026-09-05', cnTraffic: 430.00, cnAmount: 344.00,
        overseasTraffic: 890.50, overseasAmount: 98.50, exchangeRate: 7.30, cnyPayable: 1063.05, status: 'paid' },
    { key: 'b5', billNo: 'TRAFFIC20260905', companyId: 'ENT_SZ01', companyName: 'test-深圳芯视界科技有限公司',
        billingDate: '2026-09-05', cnTraffic: 1150.00, cnAmount: 920.00,
        overseasTraffic: 280.00, overseasAmount: 33.60, exchangeRate: 7.20, cnyPayable: 1161.92, status: 'paid' },
    { key: 'b6', billNo: 'TRAFFIC20260904', companyId: 'ENT_BJ03', companyName: 'test-北京智联科技有限公司',
        billingDate: '2026-09-04', cnTraffic: 1900.00, cnAmount: 1140.00,
        overseasTraffic: 0, overseasAmount: 0, exchangeRate: 7.15, cnyPayable: 1140.00, status: 'pending' },
];

// 企业视角账单列表（仅本企业）
const MOCK_ENTERPRISE_BILLS = [
    { key: 'd1', billNo: 'TRAFFIC20260906', billingDate: '2026-09-06', cnTraffic: 1280.50, cnAmount: 1024.40, overseasTraffic: 340.20, overseasAmount: 40.82, exchangeRate: 7.20, cnyPayable: 1318.30, status: 'paid' },
    { key: 'd2', billNo: 'TRAFFIC20260905', billingDate: '2026-09-05', cnTraffic: 1150.00, cnAmount: 920.00, overseasTraffic: 280.00, overseasAmount: 33.60, exchangeRate: 7.20, cnyPayable: 1161.92, status: 'paid' },
    { key: 'd3', billNo: 'TRAFFIC20260904', billingDate: '2026-09-04', cnTraffic: 980.00, cnAmount: 784.00, overseasTraffic: 210.00, overseasAmount: 25.20, exchangeRate: 7.20, cnyPayable: 965.44, status: 'paid' },
    { key: 'd4', billNo: 'TRAFFIC20260903', billingDate: '2026-09-03', cnTraffic: 1340.00, cnAmount: 1072.00, overseasTraffic: 150.00, overseasAmount: 18.00, exchangeRate: 7.20, cnyPayable: 1201.60, status: 'failed' },
    { key: 'd5', billNo: 'TRAFFIC20260902', billingDate: '2026-09-02', cnTraffic: 760.00, cnAmount: 608.00, overseasTraffic: 0, overseasAmount: 0, exchangeRate: 7.20, cnyPayable: 608.00, status: 'paid' },
    { key: 'd6', billNo: 'TRAFFIC20260901', billingDate: '2026-09-01', cnTraffic: 890.00, cnAmount: 712.00, overseasTraffic: 95.00, overseasAmount: 11.40, exchangeRate: 7.20, cnyPayable: 794.08, status: 'paid' },
];

// 国家代码映射（使用国家展示「名称(代码)」）
const COUNTRY_MAP = {
    '中国': { label: '中国大陆', code: 'CN' },
    '美国': { label: '美国', code: 'US' },
    '日本': { label: '日本', code: 'JP' },
};

// 流量明细（设备级） TODO: 联调时替换为接口数据
// 导出字段：License、设备DID、产品名称、产品ID、使用国家、使用流量(G)、币种、汇率、统计金额(¥)
const MOCK_TRAFFIC_DETAIL = [
    { key: 'd1', license: 'SZ000120260906', did: 'DID8F2A0001', productName: '4G云台摄像机', productId: 'P1001', country: '中国', traffic: 320.000000, unitPrice: 0.80, currency: 'CNY', exchangeRate: null, amount: 256.00 },
    { key: 'd2', license: 'SZ000220260906', did: 'DID8F2A0002', productName: '4G云台摄像机', productId: 'P1001', country: '美国', traffic: 80.000000, unitPrice: 0.10, currency: 'USD', exchangeRate: 7.20, amount: 57.60 },
    { key: 'd3', license: 'SZ000320260906', did: 'DID8F2A0003', productName: '4G云台摄像机', productId: 'P1001', country: '日本', traffic: 60.000000, unitPrice: 0.08, currency: 'USD', exchangeRate: 7.20, amount: 34.56 },
    { key: 'd4', license: 'SZ000420260906', did: 'DID8F2A0004', productName: '室内云台摄像机', productId: 'P1002', country: '中国', traffic: 200.000000, unitPrice: 0.80, currency: 'CNY', exchangeRate: null, amount: 160.00 },
    { key: 'd5', license: 'SZ000520260906', did: 'DID8F2A0005', productName: '电池摄像机', productId: 'P1003', country: '中国', traffic: 360.000000, unitPrice: 0.80, currency: 'CNY', exchangeRate: null, amount: 288.00 },
    { key: 'd6', license: 'SZ000620260906', did: 'DID8F2A0006', productName: '电池摄像机', productId: 'P1003', country: '美国', traffic: 140.200000, unitPrice: 0.10, currency: 'USD', exchangeRate: 7.20, amount: 100.94 },
    { key: 'd7', license: 'SZ000720260906', did: 'DID8F2A0007', productName: '室内云台摄像机', productId: 'P1002', country: '中国', traffic: 180.000000, unitPrice: 0.80, currency: 'CNY', exchangeRate: null, amount: 144.00 },
    { key: 'd8', license: 'SZ000820260906', did: 'DID8F2A0008', productName: '电池摄像机', productId: 'P1003', country: '日本', traffic: 90.000000, unitPrice: 0.08, currency: 'USD', exchangeRate: 7.20, amount: 51.84 },
];

// 单设备查询：查询条件类型（产品ID / License / DID）
// TODO: 联调时替换为接口数据
const QUERY_TYPE_OPTIONS = [
    { value: 'productId', label: '产品ID' },
    { value: 'license', label: 'License' },
    { value: 'did', label: 'DID' },
];

const QUERY_PLACEHOLDER = {
    productId: '请输入产品ID，如 P1001',
    license: '请输入完整的 License',
    did: '请输入设备 DID',
};

const STATUS_MAP = {
    paid: { label: '已扣款', color: 'success' },
    failed: { label: '扣款失败', color: 'error' },
    pending: { label: '待扣款', color: 'processing' },
};

const fmt = (v) => (v == null ? '-' : Number(v).toFixed(2));

// 国家展示：名称(代码)
const renderCountry = (v) => {
    const c = COUNTRY_MAP[v] || { label: v, code: '' };
    return <Text>{c.code ? `${c.label}(${c.code})` : c.label}</Text>;
};

// 单价展示：国内 CNY 展示 ¥/G，海外 USD 展示 $/G
const renderUnitPrice = (r) => {
    if (r.currency === 'CNY') {
        return <Text>¥{r.unitPrice.toFixed(2)}/G</Text>;
    }
    return <Text>${r.unitPrice.toFixed(2)}/G</Text>;
};

// 判断当前登录角色（平台运营 / 企业）
const getIsPlatform = () => {
    try {
        const userInfo = JSON.parse(localStorage.getItem('user_info') || '{}');
        return userInfo.role === 'platform';
    } catch (e) {
        return false;
    }
};

// ══════════════════════════════════════════════
//  主页面
// ══════════════════════════════════════════════
const DeviceTrafficBill = () => {
    const isPlatform = getIsPlatform();
    const [viewMode, setViewMode] = useState(isPlatform ? 'platform' : 'enterprise');
    const [selectedCompanyId, setSelectedCompanyId] = useState(undefined);
    const [companySearchType, setCompanySearchType] = useState('name');
    const [companySearchValue, setCompanySearchValue] = useState(undefined);

    const [detailVisible, setDetailVisible] = useState(false);
    const [detailRecord, setDetailRecord] = useState(null);

    // 抽屉内 Tab：账单 / 查询
    const [activeTab, setActiveTab] = useState('bill');
    // 单设备查询：条件类型、关键词、结果（null = 未查询，默认空态）
    const [queryType, setQueryType] = useState('productId');
    const [queryValue, setQueryValue] = useState('');
    const [queryResult, setQueryResult] = useState(null);

    // 企业视角下可选择的付费企业
    const companyOptions = Array.from(new Set(MOCK_PLATFORM_BILLS.map(b => b.companyId)))
        .map(id => {
            const b = MOCK_PLATFORM_BILLS.find(x => x.companyId === id);
            return { value: id, label: b ? b.companyName : id };
        });

    // 是否展示「付费企业」列（平台视角下展示）
    const showCompanyCol = viewMode === 'platform';

    // 当前数据源
    let billList;
    if (viewMode === 'platform') {
        billList = MOCK_PLATFORM_BILLS;
    } else {
        billList = isPlatform
            ? MOCK_PLATFORM_BILLS.filter(b => b.companyId === selectedCompanyId)
            : MOCK_ENTERPRISE_BILLS;
    }

    const handleViewModeChange = (val) => {
        setViewMode(val);
        if (val === 'enterprise') setSelectedCompanyId(undefined);
    };

    const handleView = (record) => {
        setDetailRecord(record);
        setDetailVisible(true);
    };

    const handleExport = () => {
        message.loading('正在导出数据...');
        setTimeout(() => message.success('导出成功'), 1000);
    };

    // 关闭抽屉：重置查询 Tab，保证下次打开默认为空
    const handleDetailClose = () => {
        setDetailVisible(false);
        setActiveTab('bill');
        setQueryType('productId');
        setQueryValue('');
        setQueryResult(null);
    };

    const handleQueryTypeChange = (val) => {
        setQueryType(val);
        setQueryValue('');
        setQueryResult(null);
    };

    // 单设备查询：在当前账单内按 产品ID / License / DID 匹配
    const handleQuery = () => {
        const v = queryValue.trim();
        if (!v) {
            message.warning('请输入查询内容');
            return;
        }
        const list = MOCK_TRAFFIC_DETAIL.filter(r => {
            if (queryType === 'productId') return r.productId === v;
            if (queryType === 'license') return r.license === v;
            return r.did === v;
        });
        setQueryResult(list);
    };

    const handleQueryReset = () => {
        setQueryValue('');
        setQueryResult(null);
    };

    const columns = [
        { title: '账单编号', dataIndex: 'billNo', key: 'billNo', render: v => <Text copyable style={{ fontFamily: 'monospace' }}>{v}</Text> },
        ...(showCompanyCol ? [{
            title: '付费企业', key: 'company', render: (_, r) => (
                <div><div style={{ fontWeight: 500 }}>{r.companyName}</div><Text type="secondary" style={{ fontSize: 12 }}>{r.companyId}</Text></div>
            ),
        }] : []),
        { title: '出账日', dataIndex: 'billingDate', key: 'billingDate' },
        { title: '国内流量/金额', key: 'cn', align: 'right', render: (_, r) => (
            <div><Text>{r.cnTraffic.toFixed(3)} G</Text><div><Text type="secondary" style={{ fontSize: 12 }}>¥ {r.cnAmount.toFixed(2)}</Text></div></div>
        )},
        { title: '海外流量/金额', key: 'overseas', align: 'right', render: (_, r) => (
            <div><Text>{r.overseasTraffic.toFixed(3)} G</Text><div><Text type="secondary" style={{ fontSize: 12 }}>$ {r.overseasAmount.toFixed(2)}</Text></div></div>
        )},
        { title: '汇率', dataIndex: 'exchangeRate', key: 'exchangeRate', align: 'right',
            render: v => <Text>{v?.toFixed(2)}</Text> },
        { title: '折算CNY应付', dataIndex: 'cnyPayable', key: 'cnyPayable', align: 'right',
            render: v => <Text strong style={{ color: '#fa8c16' }}>¥ {v.toFixed(2)}</Text> },
        { title: '扣款状态', dataIndex: 'status', key: 'status', align: 'center',
            render: v => { const s = STATUS_MAP[v]; return <Tag color={s.color} style={{ border: 'none' }}>{s.label}</Tag>; } },
        { title: '操作', key: 'action', width: 110, fixed: 'right', render: (_, r) => (
            <Button type="link" size="small" icon={<EyeOutlined />} onClick={() => handleView(r)}>查看账单</Button>
        )},
    ];

    const trafficColumns = [
        { title: '国家', dataIndex: 'country', key: 'country', render: renderCountry },
        { title: '流量消耗(G)', dataIndex: 'traffic', key: 'traffic', align: 'right', render: v => `${v.toFixed(3)} G` },
        { title: '币种', dataIndex: 'currency', key: 'currency', align: 'center', render: v => <Text>{v}</Text> },
        { title: '单价', key: 'unitPrice', align: 'right', render: (_, r) => renderUnitPrice(r) },
        { title: '汇率', dataIndex: 'exchangeRate', key: 'exchangeRate', align: 'right',
            render: v => v == null ? <Text type="secondary">-</Text> : <Text>{v.toFixed(2)}</Text> },
        { title: '统计金额(¥)', dataIndex: 'amount', key: 'amount', align: 'right', render: v => <Text strong>¥ {v.toFixed(2)}</Text> },
    ];

    // 查询结果（多条）列表列
    const queryColumns = [
        { title: 'License', dataIndex: 'license', key: 'license', render: v => <Text copyable style={{ fontFamily: 'monospace' }}>{v}</Text> },
        { title: '设备DID', dataIndex: 'did', key: 'did', render: v => <Text copyable style={{ fontFamily: 'monospace' }}>{v}</Text> },
        { title: '所属产品', dataIndex: 'productName', key: 'productName' },
        { title: '产品ID', dataIndex: 'productId', key: 'productId' },
        { title: '国家', dataIndex: 'country', key: 'country', render: renderCountry },
        { title: '消耗流量(G)', dataIndex: 'traffic', key: 'traffic', align: 'right', render: v => `${v.toFixed(3)} G` },
        { title: '币种', dataIndex: 'currency', key: 'currency', align: 'center' },
        { title: '汇率', dataIndex: 'exchangeRate', key: 'exchangeRate', align: 'right',
            render: v => v == null ? <Text type="secondary">-</Text> : v.toFixed(2) },
        { title: '统计金额(¥)', dataIndex: 'amount', key: 'amount', align: 'right', render: v => <Text strong>¥ {v.toFixed(2)}</Text> },
    ];

    // 查询结果渲染：未查询 → 空态；1 条 → 详情；多条 → 列表
    const renderQueryResult = () => {
        if (queryResult == null) {
            return <Empty description="请输入查询条件后查询" style={{ marginTop: 60 }} />;
        }
        if (queryResult.length === 0) {
            return <Empty description="未查询到该设备的流量数据" style={{ marginTop: 60 }} />;
        }
        if (queryResult.length === 1) {
            const r = queryResult[0];
            const c = COUNTRY_MAP[r.country] || { label: r.country, code: '' };
            return (
                <>
                    <Text strong style={{ fontSize: 15 }}>查询结果（1 条，详情展示）</Text>
                    <Descriptions bordered column={2} size="small" style={{ marginTop: 12 }}>
                        <Descriptions.Item label="License"><Text copyable style={{ fontFamily: 'monospace' }}>{r.license}</Text></Descriptions.Item>
                        <Descriptions.Item label="设备DID"><Text copyable style={{ fontFamily: 'monospace' }}>{r.did}</Text></Descriptions.Item>
                        <Descriptions.Item label="所属产品">{r.productName}</Descriptions.Item>
                        <Descriptions.Item label="产品ID">{r.productId}</Descriptions.Item>
                        <Descriptions.Item label="国家">{c.code ? `${c.label}(${c.code})` : c.label}</Descriptions.Item>
                        <Descriptions.Item label="消耗流量">{r.traffic.toFixed(3)} G</Descriptions.Item>
                        <Descriptions.Item label="币种">{r.currency}</Descriptions.Item>
                        <Descriptions.Item label="汇率">{r.exchangeRate == null ? '-' : r.exchangeRate.toFixed(2)}</Descriptions.Item>
                        <Descriptions.Item label="统计金额"><Text strong style={{ color: '#fa8c16' }}>¥ {r.amount.toFixed(2)}</Text></Descriptions.Item>
                    </Descriptions>
                </>
            );
        }
        return (
            <>
                <Text strong style={{ fontSize: 15 }}>查询结果（{queryResult.length} 条，列表展示）</Text>
                <Table size="small" columns={queryColumns} dataSource={queryResult} rowKey="key"
                    pagination={false} style={{ marginTop: 12 }} />
            </>
        );
    };

    return (
        <div style={{ padding: '24px' }}>
            <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Title level={4} style={{ marginBottom: 0 }}>设备流量账单</Title>
                <Space>
                    <Text type="secondary" style={{ fontSize: 12 }}>mock 角色视角切换</Text>
                    <Segmented
                        options={[{ label: '平台视角', value: 'platform' }, { label: '企业视角', value: 'enterprise' }]}
                        value={viewMode}
                        onChange={handleViewModeChange}
                    />
                </Space>
            </div>

            <Card bordered={false} style={{ borderRadius: 8, marginBottom: 16 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
                    <Text type="secondary">出账日：</Text>
                    <RangePicker />
                    {viewMode === 'platform' && (
                        <Space.Compact>
                            <Select
                                style={{ width: 110 }}
                                value={companySearchType}
                                onChange={(v) => { setCompanySearchType(v); setCompanySearchValue(undefined); }}
                                options={[{ value: 'name', label: '企业名称' }, { value: 'id', label: '企业ID' }]}
                            />
                            {companySearchType === 'name' ? (
                                <Select
                                    showSearch
                                    allowClear
                                    placeholder="请选择企业名称"
                                    optionFilterProp="label"
                                    filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                    options={companyOptions}
                                    value={companySearchValue}
                                    onChange={setCompanySearchValue}
                                    style={{ width: 280 }}
                                />
                            ) : (
                                <Input
                                    placeholder="请输入企业ID"
                                    allowClear
                                    value={companySearchValue}
                                    onChange={e => setCompanySearchValue(e.target.value)}
                                    style={{ width: 280 }}
                                />
                            )}
                        </Space.Compact>
                    )}
                    {viewMode === 'enterprise' && isPlatform && (
                        <Select
                            placeholder="选择企业"
                            allowClear
                            showSearch
                            optionFilterProp="label"
                            style={{ width: 240 }}
                            options={companyOptions}
                            value={selectedCompanyId}
                            onChange={setSelectedCompanyId}
                        />
                    )}
                    <Button type="primary">查询</Button>
                    <Button>重置</Button>
                </div>
            </Card>

            <Card bordered={false} style={{ borderRadius: 8 }}
                title={<Text strong style={{ fontSize: 16 }}>账单列表</Text>}
                extra={<Button icon={<DownloadOutlined />} onClick={handleExport}>导出数据</Button>}
            >
                <Table columns={columns} dataSource={billList} rowKey="key"
                    pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 条记录` }} />
            </Card>

            {/* 账单明细 Drawer（70%）：账单 / 查询 双 Tab */}
            <Drawer
                title="账单明细"
                open={detailVisible}
                onClose={handleDetailClose}
                width="70%"
            >
                {detailRecord && (
                    <Tabs
                        activeKey={activeTab}
                        onChange={setActiveTab}
                        items={[
                            {
                                key: 'bill',
                                label: '账单',
                                children: (
                                    <>
                                        <Descriptions bordered column={2} size="small" style={{ marginBottom: 16 }}>
                                            <Descriptions.Item label="账单编号">{detailRecord.billNo}</Descriptions.Item>
                                            <Descriptions.Item label="出账日">{detailRecord.billingDate}</Descriptions.Item>
                                            {showCompanyCol && (
                                                <>
                                                    <Descriptions.Item label="付费企业">{detailRecord.companyName}</Descriptions.Item>
                                                    <Descriptions.Item label="企业ID">{detailRecord.companyId}</Descriptions.Item>
                                                </>
                                            )}
                                            <Descriptions.Item label="国内流量/金额">{detailRecord.cnTraffic.toFixed(3)} G / ¥ {detailRecord.cnAmount.toFixed(2)}</Descriptions.Item>
                                            <Descriptions.Item label="海外流量/金额">{detailRecord.overseasTraffic.toFixed(3)} G / $ {detailRecord.overseasAmount.toFixed(2)}</Descriptions.Item>
                                            <Descriptions.Item label="汇率">{detailRecord.exchangeRate.toFixed(2)}</Descriptions.Item>
                                            <Descriptions.Item label="应付金额"><Text strong style={{ color: '#fa8c16' }}>¥ {fmt(detailRecord.cnyPayable)}</Text></Descriptions.Item>
                                        </Descriptions>

                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                                            <Text strong style={{ fontSize: 15 }}>流量明细</Text>
                                            <Button icon={<DownloadOutlined />} onClick={handleExport}>导出</Button>
                                        </div>
                                        <Table size="small" columns={trafficColumns} dataSource={MOCK_TRAFFIC_DETAIL} rowKey="key"
                                            pagination={false} />
                                    </>
                                ),
                            },
                            {
                                key: 'query',
                                label: '查询',
                                children: (
                                    <>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', marginBottom: 16 }}>
                                            <Space.Compact>
                                                <Select
                                                    style={{ width: 120 }}
                                                    value={queryType}
                                                    onChange={handleQueryTypeChange}
                                                    options={QUERY_TYPE_OPTIONS}
                                                />
                                                <Input
                                                    style={{ width: 320 }}
                                                    allowClear
                                                    placeholder={QUERY_PLACEHOLDER[queryType]}
                                                    value={queryValue}
                                                    onChange={e => setQueryValue(e.target.value)}
                                                    onPressEnter={handleQuery}
                                                />
                                            </Space.Compact>
                                            <Button type="primary" icon={<SearchOutlined />} onClick={handleQuery}>查询</Button>
                                            <Button onClick={handleQueryReset}>重置</Button>
                                        </div>
                                        {renderQueryResult()}
                                    </>
                                ),
                            },
                        ]}
                    />
                )}
            </Drawer>
        </div>
    );
};

export default DeviceTrafficBill;
